'use client';

type PageSectionShellProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
  scrollMode?: 'content' | 'shell';
};

export function PageSectionShell({
  header,
  children,
  className,
  headerClassName,
  contentClassName,
  contentStyle,
  scrollMode = 'content',
}: PageSectionShellProps) {
  const isShellScrollMode = scrollMode === 'shell';

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflowY: isShellScrollMode ? 'auto' : undefined,
        overscrollBehavior: isShellScrollMode ? 'contain' : undefined,
      }}
    >
      <div className={headerClassName}>{header}</div>

      <section
        className={`layout-children-container ${contentClassName ?? ''}`.trim()}
        style={{
          flex: isShellScrollMode ? '0 0 auto' : '1 1 auto',
          minHeight: isShellScrollMode ? undefined : 0,
          overflowY: isShellScrollMode ? 'visible' : 'auto',
          overscrollBehavior: isShellScrollMode ? undefined : 'contain',
          ...contentStyle,
        }}
      >
        {children}
      </section>
    </div>
  );
}
